import { render, staticRenderFns } from "./SvgSymbolList.vue?vue&type=template&id=77a1be50&scoped=true"
import script from "./SvgSymbolList.vue?vue&type=script&lang=ts"
export * from "./SvgSymbolList.vue?vue&type=script&lang=ts"
import style0 from "./SvgSymbolList.vue?vue&type=style&index=0&id=77a1be50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a1be50",
  null
  
)

export default component.exports